import { Link } from 'braid-design-system';
import type React from 'react';

import { trackPageInteraction } from 'src/modules/AnalyticsTracker';
import type { AnalyticsTrackingData } from 'src/types';

interface Props {
  href?: string;
  children: React.ReactNode;
  target?: string;
  rel?: string;
  trackingEventName: string;
  trackingActionOrigin?: string;
  trackingData?: AnalyticsTrackingData;
  onClick?: (e: React.UIEvent) => void;
}

const TrackingLink = (props: Props) => {
  const {
    href,
    onClick,
    children,
    trackingEventName,
    trackingActionOrigin,
    trackingData,
    ...restProps
  } = props;

  const handleClick = (event: React.UIEvent) => {
    if (href === '#') {
      event.preventDefault();
    }

    if (trackingEventName) {
      trackPageInteraction(
        trackingEventName,
        trackingActionOrigin,
        trackingData,
      );
    }

    if (typeof onClick === 'function') {
      onClick(event);
      return;
    }
  };

  if (!href) {
    return null;
  }

  return (
    <Link {...restProps} href={href} onClick={handleClick}>
      {children}
    </Link>
  );
};

export default TrackingLink;
